import styled from 'styled-components'
import { Headline2 } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import { AnalyticsEventDownloadPageButtonClick } from 'lib/constants/AnalyticsEventType'
import { deviceSize } from 'lib/constants/GridBreakpoints'
import { redirectToAppDownloadUrlAsync } from 'lib/features/app-links'
import useMedia from 'lib/hooks/useMedia'
import { trackEvent } from 'lib/tracking/analytics-service'
import { getMobileOS } from 'lib/tracking/attribution/device'
import DownloadBanner from '../SEO/DownloadBanner'
import { getReferrerScreen } from 'lib/formatting/url'
import { useRouter } from 'next/router'
import EarthIcon from 'assets/download/earth.png'
import EarthMobileIcon from 'assets/download/earth_mobile.png'

const Container = styled.div`
    width: 100%;
    height: auto;
    min-height: 500px;
    display: grid;
    gap: 100px;
    place-content: center;
    padding: 50px 25px;
    position: relative;
    background-color: ${theme.colors.flamingoPink};
    z-index: 10;
    a {
        display: flex;
        justify-content: center;
    }
    h2 {
        padding: 0 20%;
    }
    .buttons {
        display: flex;
        justify-content: center;
        gap: 15px;
    }
    @media (max-height: 800px) and (min-width: 1081px) {
        min-height: 600px;
        h2 {
            padding: 0 10%;
        }
    }
    @media (max-width: 1080px) {
        min-height: 600px;
        place-content: start center;
        gap: 50px;
        h2 {
            padding: 0 10%;
        }
    }
`

const Earth = styled.img`
    position: absolute;
    bottom: 0;
    z-index: -1;
    @media (max-width: 1080px) {
        left: -300px;
    }
    @media (max-width: 750px) {
        left: auto;
        right: 0;
    }
`

interface Props {
    text: string
}

const BottomDownloadBanner = ({ text }: Props) => {
    const mobileOS = getMobileOS() ?? 'ios'
    const router = useRouter()
    const referrerScreen = getReferrerScreen(router)
    const md = useMedia(deviceSize.md)

    const handleConversionDialogButtonClick = (platform: 'android' | 'ios') => {
        trackEvent(AnalyticsEventDownloadPageButtonClick, {
            useBeacon: true,
            referrerScreen,
        })
        redirectToAppDownloadUrlAsync(platform, 'downloadPage')
    }

    return (
        <Container>
            <Headline2 textAlign="center" color={theme.colors.white}>
                {text}
            </Headline2>

            <div className="buttons">
                <>
                    {md && mobileOS ? (
                        <DownloadBanner
                            type={mobileOS}
                            onClick={() => handleConversionDialogButtonClick(mobileOS)}
                            referrerScreen="download-page"
                        />
                    ) : (
                        <>
                            <DownloadBanner
                                type="android"
                                onClick={() => handleConversionDialogButtonClick('android')}
                                referrerScreen="download-page"
                            />
                            <DownloadBanner
                                type="ios"
                                onClick={() => handleConversionDialogButtonClick('ios')}
                                referrerScreen="download-page"
                            />
                        </>
                    )}
                </>
            </div>
            <Earth src={md ? EarthMobileIcon.src : EarthIcon.src} alt="earth icon" />
        </Container>
    )
}

export default BottomDownloadBanner
